export class Organization {
  constructor() {
    this.criticalPocEmail = "";
    this.criticalPocName = "";
    this.criticalPocPhone = "";
    this.criticalService = "";
    this.dateOfCrr = "";
    this.facilitatorEmail = "";
    this.facilitatorName = "";
    this.facilitatorPhone = "";
    this.id = 0;
    this.isActive = false;
    this.isActivationLoading = false;
    this.isPaid = false;
    this.locationCity = "";
    this.locationState = "";
    // 2-letter jurisdiction code (Organizations.state) — the IR overlay source of truth,
    // distinct from locationState (full-name). Optional.
    this.state = "";
    this.logo = "";
    this.organizationName = "";
    this.sector = "";
    this.isSendingCredentials = false;
    this.isDeleting = false;
    this.facilitatorTitle = 0;
    this.facilitatorTitleId = 0;
    this.organization_type = 0;
    this.organization_type_id = 0;
  }

  /**
   * @type {number}
   */
  id;

  /**
   * @type {string}
   */
  logo;

  /**
   * @type {string}
   */
  locationCity;

  /**
   * @type {string}
   */
  dateOfCrr;

  /**
   * @type {string}
   */
  criticalPocName;

  /**
   * @type {string}
   */
  criticalPocEmail;

  /**
   * @type {string}
   */
  criticalPocPhone;

  /**
   * @type {string}
   */
  criticalService;

  /**
   * @type {boolean}
   */
  isActive;

  /**
   * @type {boolean}
   */
  isActivationLoading;

  /**
   * @type {boolean}
   */
  isSendingCredentials;

  /**
   * @type {boolean}
   */
  isDeleting;

  /**
   * @type {boolean}
   */
  isPaid;

  /**
   * @type {string}
   */
  organizationName;

  /**
   * @type {string}
   */
  facilitatorName;

  /**
   * @type {string}
   */
  facilitatorPhone;

  /**
   * @type {string}
   */
  facilitatorEmail;

  /**
   * @type {number}
   */
  facilitatorTitle;

  /**
   * @type {number}
   */
  facilitatorTitleId;

  /**
   * @type {string}
   */
  locationState;

  /**
   * @type {string}
   */
  state;

  /**
   * @type {string}
   */
  sector;
  /**
   * @type {number}
   */
  organization_type;

  /**
   * @type {number}
   */
  organization_type_id;
}
